import React from 'react';
import ReactDOM from 'react-dom';

import { T } from '../../../../common/locale/translate';
import {
  createFacilitiesObject,
  fetchFilterData,
  isFilterExpired,
  localstorageAvailable,
  numeralTranslation
} from '../../services/services';

export default class Facilities extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      value: '',
      pristine: true,
      facilities: {
        categories: {
          list: []
        }
      },
      chosen_facilities: [],
      placeholder: '',
      filterDataCacheTime: 259200000 // in miliseconds
    };
  }

  componentDidMount = () => {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
    this.setInitialData();
  };

  componentWillReceiveProps = nextProps => {
    if (typeof nextProps.facilities != 'undefined' && this.state.pristine) {
      const chosen_facilities = nextProps.facilities.split(',');
      this.setState({
        chosen_facilities,
        placeholder: this.formatedPlaceholder(chosen_facilities),
        pristine: false
      });
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  render = () => {
    let facilities = this.renderFacilities();
    return (
      <div
        className={
          'facilities select-wrapper animated-text-form extended ' +
          (this.state.active ? 'active' : '')
        }
        ref={() => {
          this.returnSearchedValue = this.returnSearchedValue.bind(this);
        }}
      >
        <label className="animated-text-label" htmlFor="stars-input-1">
          <span className="animated-text-label-name">{this.props.title}</span>
        </label>
        <i className="dropdown-icon fa fa-chevron-down" />
        <div className="desktop">
          <input
            id="stars-input-1"
            type="text"
            value={this.state.value}
            className="animated-text-input stars-input"
            onFocus={this.handleFocus}
            onChange={this.handleInputChange}
            placeholder={this.state.placeholder}
          />
        </div>
        <div className="mobile">
          <label className="animated-text-label" onClick={this.handleOpen}>
            <span className="animated-text-input">
              {this.state.placeholder}
            </span>
          </label>
        </div>
        <div className="dropdown-menu">
          <div className="dropdown-input-wrapper mobile">
            <label className="animated-text-label" htmlFor="stars-input-2">
              {' '}
              <span className="animated-text-label-name">
                {this.props.title}
              </span>{' '}
            </label>
            <input
              id="stars-input-2"
              type="text"
              value={this.state.value}
              className="animated-text-input stars-input"
              onFocus={this.handleFocus}
              onChange={this.handleInputChange}
              placeholder={this.state.placeholder}
            />
          </div>
          <div className="reset-filter-custom mobile">
            <span onClick={this.handleReset} className="reset">
              <span> {T('clear')} </span>
            </span>
            <span onClick={this.handleClose} className="confirm">
              <span> {T('choose')} </span>
            </span>
          </div>
          <i className="fa fa-times close-icon" onClick={this.handleClose} />
          <ul className="dropdown-wrapper">
            {facilities.length ? (
              facilities
            ) : (
              <li className="no-option">{T('no_options')}</li>
            )}
          </ul>
          <div className="reset-filter desktop more-fiters">
            <span onClick={this.handleReset} className="reset">
              <i className="fa fa-times reset-icon" />
              <span> {T('clear')} </span>
            </span>
            <span onClick={this.handleClose} className="confirm">
              <span> {T('choose')} </span>
            </span>
          </div>
        </div>
      </div>
    );
  };

  setInitialData = () => {
    if (localstorageAvailable()) {
      if (isFilterExpired('facilities', this.state.filterDataCacheTime)) {
        this.updateFilterSource();
      } else {
        const filter_data = JSON.parse(
          localStorage.getItem('facilities_filter')
        );
        this.setState({ facilities: filter_data });
      }
    } else {
      this.updateFilterSource();
    }
  };

  updateFilterSource = () => {
    fetchFilterData('facilities_filter').then(
      response => {
        const filter_data = createFacilitiesObject(response.data);
        if (localstorageAvailable()) {
          localStorage.setItem(
            'facilities_filter',
            JSON.stringify(filter_data)
          );
          localStorage.setItem(
            'facilities_filter_last_update',
            new Date().getTime()
          );
        }
        this.setState({ facilities: filter_data });
      },
      error => {
        console.log('Error when fetching regions filter', error);
      }
    );
  };

  handleOpen = () => this.setState({ active: true });

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if ((!domNode || !domNode.contains(event.target)) && this.state.active) {
      this.setState({
        active: false,
        placeholder: this.formatedPlaceholder(this.state.chosen_facilities),
        value: ''
      });
    }
  };

  handleInputChange = event =>
    this.setState({
      value: event.target.value.replace(/[.*+?^${}()|[\]\\]/g, '')
    });

  handleCheckboxChange = event => {
    let chosen_facilities = this.state.chosen_facilities;
    if (chosen_facilities.indexOf(event.target.value) > -1) {
      chosen_facilities = chosen_facilities.filter(
        facility => facility !== event.target.value
      );
    } else {
      chosen_facilities.push(event.target.value);
    }
    this.setState({
      chosen_facilities,
      placeholder: this.formatedPlaceholder(chosen_facilities)
    });
  };

  handleClose = () =>
    this.setState({
      active: false,
      value: '',
      placeholder: this.formatedPlaceholder(this.state.chosen_facilities)
    });

  handleFocus = () => this.setState({ active: true, placeholder: '' });

  handleReset = () =>
    this.setState({ chosen_facilities: [], value: '', placeholder: '' });

  renderFacilities = () => {
    return this.state.value !== ''
      ? this.renderSearchedFacilities()
      : this.renderFacilitiesElements();
  };

  formatedPlaceholder = chosen_facilities => {
    return chosen_facilities.length > 0
      ? `${T('chosen')} ${chosen_facilities.length} ${numeralTranslation(
          chosen_facilities.length,
          [T('option'), T('option_first_plural'), T('option_second_plural')]
        )}`
      : '';
  };

  renderFacilitiesElements = () => {
    const category_names = this.state.facilities.categories.list;
    const facilites = this.state.facilities.categories;
    return category_names.map((category, i) => {
      return (
        <div key={`facility_category_${i}`}>
          <div className="dropdown-header">
            <span> {category} </span>
          </div>
          <ul className="dropdown-wrapper">
            {facilites[category].facilities.map(facility => {
              const isChecked =
                this.state.chosen_facilities.indexOf(`${facility.id}`) > -1;
              return (
                <li key={`facility_${facility.id}`} className="item">
                  <input
                    type="checkbox"
                    id={`facility_${facility.id}`}
                    name="facility"
                    onChange={this.handleCheckboxChange}
                    value={facility.id}
                    checked={isChecked}
                  />
                  <label htmlFor={`facility_${facility.id}`}>
                    {facility.name}
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      );
    });
  };

  renderSearchedFacilities = () => {
    let search = new RegExp(this.state.value, 'i');
    let searched_facilities = this.state.facilities.facilities_list.filter(
      (facility, i) => search.test(facility.name) && i < 80
    );
    return searched_facilities.map(facility => {
      const isChecked =
        this.state.chosen_facilities.indexOf(`${facility.id}`) > -1;
      return (
        <li key={`facility_${facility.id}`} className="item">
          <input
            type="checkbox"
            id={`facility_${facility.id}`}
            name="facility"
            onChange={this.handleCheckboxChange}
            value={facility.id}
            checked={isChecked}
          />
          <label htmlFor={`facility_${facility.id}`}>{facility.name}</label>
        </li>
      );
    });
  };

  returnSearchedValue = () =>
    this.state.chosen_facilities.length ? this.state.chosen_facilities : false;
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/facilities.js